export default "__VITE_ASSET__7d8b2ef8__"